
export enum AuctionType {
    "TENDER" = "TENDER",
    "SELLING" = "SELLING"
}
